import { FaDiscord } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useProfiles } from "../../../../context/ProfilesProvider";
import DashCard from "../../dashboard/DashCard";

// The tipper's linked Discord account, on their home page.
const DiscordProfileWidget = () => {
  const { discordProfile, discordLoading } = useProfiles();
  if (discordLoading || !discordProfile) {
    return null;
  }
  return (
    <DashCard
      title={
        <>
          <FaDiscord className="text-primary" /> Discord
        </>
      }
      aside={
        <Link to="/link-accounts" className="link link-primary text-xs">
          Manage
        </Link>
      }
    >
      <div className="text-lg font-semibold text-primary break-all">
        @{discordProfile.username}
      </div>
      <div className="text-xs text-base-content/60">
        Where the bot DMs you and where the VIP role goes.
      </div>
    </DashCard>
  );
};

export default DiscordProfileWidget;
